"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.dismissUploadError = dismissUploadError;
exports.refreshReport = refreshReport;
exports.loadReportIfNeeded = loadReportIfNeeded;
exports.reset = reset;
exports.saveSelectedReport = saveSelectedReport;
exports.selectReportById = selectReportById;
exports.updateReportWithAppDataField = updateReportWithAppDataField;
exports.updateReport = updateReport;
exports.updateReportWithStepFormData = updateReportWithStepFormData;
exports.validationStateOfStepChanged = validationStateOfStepChanged;
exports.loadContingentOfCurrentReportDefinition = loadContingentOfCurrentReportDefinition;

var _reduxActions = require("redux-actions");

var _reactRefetch = require("react-refetch");

var _constants = require("./constants");

var C = _interopRequireWildcard(_constants);

var _API = require("../../API");

var _lodash = require("lodash");

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _actions = require("../reports/actions");

var reportActions = _interopRequireWildcard(_actions);

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};
function dismissUploadError() {
    return function (dispatch, getState) {
        return dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_UPDATE_DISMISS_ERROR, function () {
            return {};
        })());
    };
}
function refreshReport(reportUid) {
    var _this = this;

    return function (dispatch, getState) {
        return __awaiter(_this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return dispatch(reportActions.loadReport(reportUid));

                        case 2:
                            return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));
    };
}
// action looks for given reportUid in store, if its not found, all reports with its definitions gets loaded from server and looked up again
// XXX replace with loadReport(uid)
function loadReportIfNeeded(reportUid) {
    var _this2 = this;

    var forceReload = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

    return function (dispatch, getState) {
        return __awaiter(_this2, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
            var reportLookup, report, loadReportWithLookup, loadedReport;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            loadReportWithLookup = function loadReportWithLookup() {
                                return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    _context2.next = 2;
                                                    return dispatch(reportActions.loadReports());

                                                case 2:
                                                    return _context2.abrupt("return", reportLookup());

                                                case 3:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, this);
                                }));
                            };

                            // lookup report in store

                            reportLookup = function reportLookup() {
                                var reports = (0, _selectn2.default)("reports.value", getState().reports);
                                return (0, _lodash.find)(reports, function (report) {
                                    return report.uid === reportUid;
                                });
                            };

                            report = null;

                            if (!forceReload) {
                                report = reportLookup();
                            }
                            // load all reports from server, loadReports action includes loading of reportdefinitions
                            // try to find the reportuid within freshly loaded reports

                            ;

                            if (!report) {
                                _context3.next = 9;
                                break;
                            }

                            return _context3.abrupt("return", report);

                        case 9:
                            _context3.next = 11;
                            return loadReportWithLookup();

                        case 11:
                            loadedReport = _context3.sent;

                            if (!loadedReport) {
                                _context3.next = 16;
                                break;
                            }

                            return _context3.abrupt("return", loadedReport);

                        case 16:
                            throw new Error("can´t find report with report uid " + reportUid);

                        case 17:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));
    };
}
function reset() {
    return function (dispatch, getState) {
        return dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_RESET, function () {
            return {};
        })());
    };
}
function saveSelectedReport(state) {
    var _this3 = this;

    return function (dispatch, getState) {
        return __awaiter(_this3, void 0, void 0, regeneratorRuntime.mark(function _callee5() {
            var _this4 = this;

            var _getState$reportDetai, selectedReport, reportStepData, reportData, typeReferences, newReport, target, _ret, _target;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _getState$reportDetai = getState().reportDetail;
                            selectedReport = _getState$reportDetai.selectedReport;
                            reportStepData = _getState$reportDetai.reportStepData;
                            reportData = _getState$reportDetai.reportData;
                            typeReferences = _getState$reportDetai.typeReferences;
                            newReport = (0, _lodash.cloneDeep)(selectedReport);
                            // update state if provided

                            newReport.state = state ? state : newReport.state;
                            newReport = (0, _index.applySteps)(newReport, reportStepData);
                            // finally also inject all current typeReferences...
                            newReport.data.typeReferences = typeReferences;
                            target = _API.API.updateReport(newReport);

                            if (!state) {
                                _context5.next = 17;
                                break;
                            }

                            return _context5.delegateYield(regeneratorRuntime.mark(function _callee4() {
                                var r, updateStateTarget, promiseState;
                                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                    while (1) {
                                        switch (_context4.prev = _context4.next) {
                                            case 0:
                                                _context4.next = 2;
                                                return dispatch(saveSelectedReport());

                                            case 2:
                                                r = _context4.sent;
                                                updateStateTarget = null;
                                                _context4.t0 = state;
                                                _context4.next = _context4.t0 === "approved" ? 7 : _context4.t0 === "closed" ? 9 : _context4.t0 === "open" ? 11 : 13;
                                                break;

                                            case 7:
                                                updateStateTarget = _API.API.approveReport(newReport.uid);
                                                return _context4.abrupt("break", 13);

                                            case 9:
                                                updateStateTarget = _API.API.closeReport(newReport.uid);
                                                return _context4.abrupt("break", 13);

                                            case 11:
                                                updateStateTarget = _API.API.reopenReport(newReport.uid);
                                                return _context4.abrupt("break", 13);

                                            case 13:
                                                promiseState = _reactRefetch.PromiseState.create(target);

                                                dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_UPDATE_REPORT, function () {
                                                    return promiseState;
                                                })());
                                                return _context4.abrupt("return", {
                                                    v: _API.client.requestReduxType(target, [C.REPORTDETAILS_UPDATE_REPORT, C.REPORTDETAILS_UPDATE_REPORT_SUCCESS, C.REPORTDETAILS_UPDATE_REPORT_FAILED], dispatch).then(function (value) {
                                                        return _API.client.requestRedux(updateStateTarget, [C.REPORTDETAILS_UPDATE_REPORT, C.REPORTDETAILS_UPDATE_REPORT_SUCCESS, C.REPORTDETAILS_UPDATE_REPORT_FAILED], dispatch);
                                                    }).then(function (value) {
                                                        return loadReportIfNeeded(newReport.uid, true)(dispatch, getState);
                                                    }).then(function (value) {
                                                        promiseState.value = value;
                                                        promiseState.pending = false;
                                                        return dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_UPDATE_REPORT_SUCCESS, function () {
                                                            return promiseState;
                                                        })());
                                                    }).catch(function (error) {
                                                        promiseState.reason = error;
                                                        promiseState.pending = false;
                                                        return dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_UPDATE_REPORT_FAILED, function () {
                                                            return promiseState;
                                                        })());
                                                    })
                                                });

                                            case 16:
                                            case "end":
                                                return _context4.stop();
                                        }
                                    }
                                }, _callee4, _this4);
                            })(), "t0", 12);

                        case 12:
                            _ret = _context5.t0;

                            if (!((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object")) {
                                _context5.next = 15;
                                break;
                            }

                            return _context5.abrupt("return", _ret.v);

                        case 15:
                            _context5.next = 19;
                            break;

                        case 17:
                            _target = _API.API.updateReport(newReport);
                            return _context5.abrupt("return", _API.client.requestReduxType(_target, [C.REPORTDETAILS_UPDATE_REPORT, C.REPORTDETAILS_UPDATE_REPORT_SUCCESS, C.REPORTDETAILS_UPDATE_REPORT_FAILED], dispatch));

                        case 19:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));
    };
}
function selectReportById(reportUid) {
    var _this5 = this;

    return function (dispatch, getState) {
        return __awaiter(_this5, void 0, void 0, regeneratorRuntime.mark(function _callee6() {
            var reports;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            reports = (0, _selectn2.default)("reports.value", getState().reports);
                            // wait for report

                            _context6.next = 3;
                            return dispatch(refreshReport(reportUid)).then(function (report) {
                                if (report === null) {
                                    throw new Error("Report with uid " + reportUid + " not found, please go back to list and try again (it might have been upgraded in the meantime).");
                                }
                                var reportDefinition = (0, _lodash.chain)(getState().reports.reportDefinitions).filter(function (definition) {
                                    return definition.uid === report.definitionUid;
                                }).map(function (definition) {
                                    return {
                                        selectedReport: report,
                                        selectedReportDefinition: definition
                                    };
                                }).last().value();
                                if (reportDefinition) {
                                    return dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_SELECT_REPORT, function () {
                                        return reportDefinition;
                                    })());
                                } else {
                                    throw new Error("can´t find reportdefiniton for report with uid: " + reportUid);
                                }
                            });

                        case 3:
                            return _context6.abrupt("return", _context6.sent);

                        case 4:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));
    };
}
function updateReportWithAppDataField(appDataField) {
    var _this6 = this;

    return function (dispatch, getState) {
        return __awaiter(_this6, void 0, void 0, regeneratorRuntime.mark(function _callee7() {
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            return _context7.abrupt("return", dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_UPDATE_REPORT_APP_DATA_FIELD, function () {
                                return appDataField;
                            })()));

                        case 1:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));
    };
}
function updateReport(report) {
    var _this7 = this;

    return function (dispatch, getState) {
        return __awaiter(_this7, void 0, void 0, regeneratorRuntime.mark(function _callee8() {
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            return _context8.abrupt("return", _API.client.requestReduxType(_API.API.updateReport(report), [C.REPORTDETAILS_UPDATE_REPORT, C.REPORTDETAILS_UPDATE_REPORT_SUCCESS, C.REPORTDETAILS_UPDATE_REPORT_FAILED], dispatch));

                        case 1:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));
    };
}
function updateReportWithStepFormData(reportStepId, formData) {
    var _this8 = this;

    return function (dispatch, getState) {
        return __awaiter(_this8, void 0, void 0, regeneratorRuntime.mark(function _callee9() {
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            return _context9.abrupt("return", dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_UPDATE_REPORT_FORM_DATA, function () {
                                return { reportStepId: reportStepId, formData: formData };
                            })()));

                        case 1:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));
    };
}
function validationStateOfStepChanged(reportStepData, valid) {
    return function (dispatch, getState) {
        reportStepData.isValid = valid;
        return dispatch((0, _reduxActions.createAction)(C.REPORTDETAILS_REPORTSTEP_VALIDATION_CHANGED, function () {
            return reportStepData;
        })());
    };
}
function loadContingentOfCurrentReportDefinition() {
    return function (dispatch, getState) {
        var selectedReportDefinition = (0, _selectn2.default)("selectedReportDefinition", getState().reportDetail);
        var uid = (0, _selectn2.default)("uid", selectedReportDefinition);
        if (uid) {
            console.log("found uid");
            var target = _API.API.getReportContingent(uid);
            return _API.client.requestReduxJSON(target, [C.REPORTDETAILS_REPORT_CONTINGENT, C.REPORTDETAILS_REPORT_CONTINGENT_SUCCESS, C.REPORTDETAILS_REPORT_CONTINGENT_FAILED], dispatch);
        } else {
            throw new Error("no selected report definition");
        }
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/actions.ts
 ** module id = 48
 ** module chunks = 0
 **/